import { CardMedia, Stack } from '@mui/material';
import * as React from 'react';
import Carousel from 'react-material-ui-carousel';
import { EMaterialCategory, EProducer } from '../../shared/enum';
import variable from '../../shared/style/variable';
import GenericMaterial from './GenericMaterial';
import { Context } from './Index';
import MaccaferriMaterial from './MaccaferriMaterial';
import RipRap from './RipRap';

interface IMaterialDetailProps {}

const MaterialDetail = (props: IMaterialDetailProps) => {
    const context = React.useContext(Context);

    let materialElement: React.ReactNode;

    switch (context?.baseMaterial.producer) {
        case EProducer.Maccaferri:
            materialElement = <MaccaferriMaterial />;
            break;

        case EProducer.Other:
            if (context?.baseMaterial.category == EMaterialCategory.RipRap) {
                materialElement = <RipRap />;
            } else {
                materialElement = <GenericMaterial />;
            }
            break;
    }

    return (
        <Stack flexGrow={1} spacing={2} justifyContent={'center'}>
            <Carousel
                indicators={context!.baseMaterial!.images?.length! > 1}
                navButtonsProps={{
                    style: {
                        backgroundColor: variable.white,
                        color: variable.greenLight,
                        border: `0.1rem solid ${variable.greenLight}`,
                        borderRadius: 0,
                        height: '2rem',
                        width: '2rem',
                    },
                }}>
                {context!.baseMaterial!.images?.map((item, i) => (
                    <CardMedia key={`materialCard_${i}`} height={180} width={300} component='img' image={item.imageUrl} alt={`image-${i}`} />
                ))}
            </Carousel>
            {materialElement}
        </Stack>
    );
};

export default MaterialDetail;
